/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum QuoteRatingTypeEnum {
    POLICY_LIMITS = 1,
    OPTION = 2,
    SELECTION = 3,
    X_MOD = 4,
    MANUAL_PREMIUM = 5,
    SUBJECT_PREMIUM = 6,
    MODIFIED_PREMIUM = 7,
    STANDARD_PREMIUM = 8,
    ESTIMATED_ANNUAL_PREMIUM = 9,
    ENTERED_RATE = 10,
    SCHEDULE_FORM = 11,
    MIN_PREM = 12,
    DISCOUNT_TABLE = 13,
    EXPENSE_CONSTANT = 14,
    REQUIRED = 15,
    LCM = 16,
    EL_BALANCE_TO_MIN = 17,
    ENTERED_AMOUNT = 18,
    DISCOUNT_TIER = 19,
    SPECIFIC_WAIVER_FORM = 20,
    AGENCY_DISCOUNT = 21,
    DISCOUNT_TABLE_EDIT = 22,
    EXPOSURE_BASIS = 23,
    REGION = 24,
    SHORT_RATE = 25,
    LARGE_DEDUCTIBLE = 26,
}
